import { ChipProps } from '@mui/material';
import { MessageStatus } from '@schooly/api';
import { TagSelect } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { $enum } from 'ts-enum-util';

export type MessageStatusTagSelectProps = {
  status: MessageStatus;
} & Omit<ChipProps, 'label'>;

const OPTIONS = $enum(MessageStatus).map((value, key) => ({ value, label: key }));

export const MessageStatusTagSelect: FC<MessageStatusTagSelectProps> = ({ status, ...props }) => {
  const label = OPTIONS.find((o) => o.value === status)?.label;
  const { formatMessage } = useIntl();

  return (
    <TagSelect
      label={label ? formatMessage({ id: `options-message-status-${label}` }) : label}
      {...props}
    />
  );
};
